import { mount } from "@vue/test-utils";
import NumberInput from "@/components/core/NumberInput";

describe("NumberInput test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(NumberInput);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component NumberInput", () => {
    expect(wrapper).toBeDefined();
  });
});
